import { styled } from "../../../../../../../../styles";

export const Container = styled("div", {
  display: "flex",
  flexDirection: "column",
  width: "fit-content",
  maxHeight: "74px",
  flexWrap: "wrap",
  columnGap: "22px",
});

export const StyledLegend = styled("li", {
  gap: "8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",

  color: "$gray-90",

  lineHeight: "20px",
  fontSize: "$text-md",

  marginLeft: "-2px",
});

export const LegendIconWrapper = styled("span", {
  width: "16px",
  height: "16px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  svg: {
    display: "block",
  },
});
